import {Box, Heading, HStack} from 'platform/foundation';
import {useFormatCurrency} from 'platform/locale';

import {useCallback} from 'react';

import {mergeAll, defaultTo} from 'ramda';

import {GetIssueNoteResponse} from '@dms/api/warehouse';
import i18n from '@dms/i18n';
import {DmsDataGrid, useTenant} from '@dms/shared';
import {useWarehouseParams} from '@dms/warehouse/shared-components';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import type {QueryFilterObject} from 'features/eag-grid';

interface ListOfItemsTabProps extends RequiredTestIdProps {
  issueNote: GetIssueNoteResponse | undefined;
}

export function ListOfItemsTab(props: ListOfItemsTabProps) {
  const {issueNoteId} = useWarehouseParams();
  const currencyFormatter = useFormatCurrency();
  const tenant = useTenant();
  const queryModifier = useCallback(
    (filter: QueryFilterObject) => mergeAll([filter, {issueNoteId}]),
    [issueNoteId]
  );

  const totalValue = currencyFormatter(
    defaultTo(0, props.issueNote?.summaryInformation.totalValue.amount),
    defaultTo(tenant.tenantCurrency, props.issueNote?.summaryInformation.totalValue.currency),
    2
  );

  return (
    <Box height="100%">
      <Box height="95%">
        <DmsDataGrid
          gridCode="warehouse-issue-note-items"
          queryModifier={queryModifier}
          data-testid={suffixTestId('issuedItems', props)}
        />
      </Box>
      <HStack minHeight={15} align="center" justify="space-between">
        <Heading size={5}>{i18n.t('general.labels.totalValue')}</Heading>
        <Heading size={5}>{totalValue}</Heading>
      </HStack>
    </Box>
  );
}
